module.exports = __webpack_public_path__ + "img/Location_Vancouver.803668bc.png";